
export default {
  data() {
    return {
      plan: "monthly",
    };
  },
};
